import { makeStyles, Theme } from '@material-ui/core'
import { BreakpointValues } from '@material-ui/core/styles/createBreakpoints'
import { HTMLProps, PropsWithChildren } from 'react'

const useStyle = makeStyles((theme: Theme) => ({
  container: (props: { maxWidth?: keyof BreakpointValues }) => ({
    maxWidth: `${theme.breakpoints.values[props.maxWidth || 'lg']}px`,
    margin: '0 auto',
    padding: theme.spacing(0, 5),
  }),
}))

export const Container = (
  props: { maxWidth?: keyof BreakpointValues } & PropsWithChildren<
    HTMLProps<HTMLDivElement>
  >
) => {
  const cn = useStyle(props)

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { className, children, maxWidth, ...rest } = props

  return (
    <div className={`${cn.container} ${className}`} {...rest}>
      {children}
    </div>
  )
}
